export default {"src":"/_next/static/media/fresh-pack-icon.70aeeacb.svg","height":29,"width":78,"blurWidth":0,"blurHeight":0};